import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';

@Component({
  selector: 'signin-redirect-callback',
  templateUrl: './signin-redirect-callback.component.html',
  styleUrls: ['./signin-redirect-callback.component.scss']
})
export class SigninRedirectCallbackComponent implements OnInit {

  constructor(private router: Router,
    private oauthService: OAuthServiceService) { }

  ngOnInit() {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (!data) {
          this.router.navigate(['/'])
        }
      }
    });
  }
}
